import script from "./TextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TextArea.vue?vue&type=script&setup=true&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=706aa68c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706aa68c"]])

export default __exports__